/**
 * 多语言翻译函数，TODO 未实现
 *
 * @param value - 需要翻译的文本
 * @returns 翻译后的文本
 */
export const $t = (value: string) => value
